<template>
	<div class="select-container" @click.stop="toggleDropdown">
		<div class="select-header">
			<div class="icon-container">
				<img v-if="showIcon" :src="selected.icon" alt="" />
				<span class="region">{{ selected.text }}</span>
				<span
					class="material-symbols-outlined arrow"
					translate="no"
					@click="togglePopupAndRotate"
					:class="{ rotate: dropdownOpen }"
				>
					expand_more
				</span>
			</div>
		</div>
		<div v-if="dropdownOpen" class="select-options">
			<div
				v-for="(option, index) in options"
				:key="index"
				@click="selectOption(option)"
				:class="{ active: value === option }"
				class="option"
			>
				<img v-if="showIcon" :src="option.icon" alt="" />
				<p class="region">{{ option.text }}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CustomSelector3',
	props: {
		options: {
			type: Array,
			required: true,
		},
		value: {
			type: String,
		},
		showIcon: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			dropdownOpen: false,
			selected: '',
		}
	},
	mounted() {
		this.selected = this.options.find((i) => i.value === this.value)
		document.addEventListener('click', this.closeDropdown)
	},
	computed: {
		isValidValue() {
			return (
				this.value !== null && this.value !== undefined && this.value !== ''
			)
		},
	},
	beforeDestroy() {
		document.removeEventListener('click', this.closeDropdown)
	},
	methods: {
		toggleDropdown() {
			this.dropdownOpen = !this.dropdownOpen
		},
		closeDropdown() {
			this.dropdownOpen = false
		},
		selectOption(option) {
			this.toggleDropdown()
			this.selected = option
			this.$emit('input', option.value)
		},
	},
}
</script>
